import { render, staticRenderFns } from "./orderSubmit.vue?vue&type=template&id=74b47041&scoped=true"
import script from "./orderSubmit.vue?vue&type=script&lang=js"
export * from "./orderSubmit.vue?vue&type=script&lang=js"
import style0 from "./orderSubmit.vue?vue&type=style&index=0&id=74b47041&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b47041",
  null
  
)

export default component.exports